import {
  Component,
  OnInit,
  Input
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { TransactionStatus } from "../../../../core/model/transaction.status";
import { AccountService } from "src/app/core/service/account.service";

@Component({
  selector: "app-transaction-details-modal",
  templateUrl: "./transaction-details-modal.component.html",
  styleUrls: ["./transaction-details-modal.component.scss"],
})
export class TransactionDetailsModalComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    public accountService: AccountService
  ) { }

  @Input() public transaction: any;
  transactionStatus: Record<string, string> = TransactionStatus as unknown as Record<string, string>;

  ngOnInit() { }
}

